var usePRodSIte = true;

if (usePRodSIte) {
    var CONST_API_URI = 'https://www.globalong.com';
} else {
    //var CONST_API_URI = 'https://testsite.globalong.com';
    var CONST_API_URI = 'https://www.globalongdev.com';
}

export const API_URI = CONST_API_URI;

// Versement par chèque : passer à true pour réafficher ce mode de paiement
// dans le tunnel de paiement (OrderDashboard).
export const CHECK_PAYMENT_ENABLED = false;
